/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import type { CSSProperties } from 'react';

export interface FieldsetSectionRowProps {
    label: React.ReactNode;
    labelSeparator?: string;
    labelStyles?: CSSProperties;
    value: React.ReactNode;
    valueStyles?: CSSProperties;
}

export const FieldsetSectionRow: React.FC<FieldsetSectionRowProps> = ({ label, labelSeparator = ':', labelStyles, value, valueStyles }) => {
    const cellStyles: CSSProperties = {
        display: 'flex',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    };

    return (
        <>
            <div
                style={{
                    ...cellStyles,
                    gridColumn: '1 / 2',
                    ...labelStyles,
                }}
            >
                {label}
                {labelSeparator}
            </div>

            <div
                style={{
                    ...cellStyles,
                    gridColumn: '2 / 2',
                    ...valueStyles,
                }}
            >
                {value}
            </div>
        </>
    );
};
